// notificationApi.js

import api from "./api"; // adjust path to your api instance

/**
 * Fetch all notifications for the current user
 */
export async function fetchNotifications({ page = 1, page_size = 20 } = {}) {
  try {
    const response = await api.get("event-notifications/", {
      params: { page, page_size },
    });
    const data = response?.data;
    if (data && data.results) {
      return {
        results: data.results,
        hasNext: Boolean(data.next),
        count: data.count || data.results.length,
      };
    }
    if (Array.isArray(data)) {
      return {
        results: data,
        hasNext: false,
        count: data.length,
      };
    }
    return { results: [], hasNext: false, count: 0 };
  } catch (error) {
    console.error("Error fetching notifications: ", error);
    return { results: [], hasNext: false, count: 0 };
  }
}

/**
 * Mark a notification as seen by its ID
 */
export async function markAllNotificationsSeen() {
  try {
    const res = await api.post("event-notifications/mark-all-seen/");
    return res.data;
  } catch (err) {
    console.error("Error marking all notifications seen:", err);
  }
}

export async function fetchUnreadCount() {
  const res = await api.get("event-notifications/unread-count/");
  return res.data.count;
}

export async function fetchAnnouncements() {
  try {
    const response = await api.get("event-notifications/announcements/");
    return response.data;
  } catch (error) {
    console.error("Error fetching announcements:", error);
    return [];
  }
}

export async function markNotificationSeen(uuid) {
  try {
    await api.patch(`event-notifications/${uuid}/seen/`, {});
  } catch (err) {
    console.error("Error marking notification seen:", err);
  }
}